export default __webpack_public_path__ + "static/pattern-2fb042a075cc61ed1e28703356995988.jpg";